import React from "react";
import { Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Style from "../../../../styles/js/StyleCallList.js";
import IconButton from '@mui/material/IconButton';
import DescriptionIcon from '@mui/icons-material/Description';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import CircularProgressWithLabel from "../../../../components/common/CircularProgressWithLabel.js";
import { formatDateDDMMYYYYHHMM } from "../../../../plas/utils";
import service from "../../../../plas/services/calls/service";

export default function Results( { application } ) {

  const style = Style();

  const [downloadingA, setDownloadingA] = React.useState({}); // Descargas de auxiliary files


  const getResultFile = (call, file) => {
    
    setDownloadingA(prevState => {
      const state = { ...prevState };
      state[file.id] = 0;
      return state;
    });

    service.api.callResults.getFile(call.id, call.result.id, file.id,  {
      success: () =>  { 
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = undefined;
          return state;
        });
      },
      error: () =>  { 
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = undefined;
          return state;
        });
      } ,
      onDownloadProgress: (value) => {
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = value;
          return state;
        });
      }
    });
  }

  return (
    <div className={style.row}>
      <Card style={{ marginTop: "15px", marginBottom: "15px"}}>
        <div>
          <div className={style.itemHeader} >
            <Typography className={style.titleInitial}>
              Resultados
            </Typography>
          </div>
          <div style={{ paddingLeft: "12px", paddingRight: "12px", textAlign: "left"}}>
            <div className={style.itemContent}>
              <Typography>
                La última actualización de los resultados de la convocatoria fue {formatDateDDMMYYYYHHMM(application.call.result.time)}
              </Typography>
              <Stack style={{marginTop: "10px"}} direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
                <Typography style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center", width: "70px"}}>
                  Actas de resultados
                </Typography>
                { application.call.result.files.map((file) => (
                  <div>
                  { downloadingA[file.id] !== undefined ? 
                    (
                    <Stack alignItems="center" style={{width:"110px"}}>
                      <CircularProgressWithLabel style={{width:"35px", height:"35px" }} value={downloadingA[file.id]} />
                    </Stack>)
                    :(
                    <Stack alignItems="center" style={{width:"110px"}}>
                     <IconButton size="large" width="50px"  height="50px" onClick={ () => { getResultFile(application.call,file); }} >
                        <DescriptionIcon fontSize="inherit" />
                      </IconButton>
                      <Tooltip title={file.bin.name}>
                        <span style={{fontSize:"14px", textOverflow: "ellipsis", whiteSpace:"nowrap", width:"100%", textAlign:"center", overflow:"hidden"}}>{file.bin.name}</span>
                      </Tooltip>
                    </Stack>)
                  }
                  </div>
                  ))
                }
              </Stack>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

}
